export enum WheelchairAccessibilityEnum {
  ACCESSIBLE = true,
  INACCESSIBLE = false,
  PARTIAL = "partial",
  UNKNOWN = undefined
};